import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { Keyboard, Text, View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import CommonTextInputWeb from "../../../../common/CommonTextInputWeb";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import { TouchableOpacity, Image } from "react-native";
import ImageComponent from "../../../../Components/ImageComponent";
import WalletPopup from "./WalletPopup";
import NotificationPopup from "./NotificationPopup";
import MessagePopup from "./MessagePopup";
import ProfilePopup from "./ProfilePopup";
import {
  CommonActions,
  RouteProp,
  StackActions,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { useUserData } from "../../../../context/UserDataContext";
import { toast } from "react-toastify";
import { CropImage } from "../../../../Components/choose-avatar-components/CropImage";
import AsyncStorage from "@react-native-async-storage/async-storage";
import CheckInPopup from "../../../../Components/CheckInPopup";
import CoinsPopup from "../../../../Components/home-common-components/WhatAreCoinsPopup";
import ReferAndEarn from "../../../../Components/ReferAndEarn";
import { base_url, endpoints, dynamicBlitzUrl } from "../../../../Api/configs";
import CustomCoinToast from "../../../../Components/CustomCoinToast";
import CornfirmPurchaseBeltModal from "../BeltScreens/CornfirmPurchaseBeltModal";
import {
  fetchPaymentBeltExchangeEnhanced,
  fetchUserBalanceEnhanced,
} from "../../../../services/eventsAPIEnhanced";
import { handleApiError } from "../../../../services/errorHandler";
import BeltPurchaseSuccessModal from "../BeltScreens/BeltPurchaseSuccessModal";
import RedeemCreditsModal from "../../../../Components/profile-common-components/RedeemCreditsModal";
import { useChat } from "../../../../context/ChatContext";
import useAdminStatus from "../../../../utility/hooks/useAdminStatus";
import { useNotifications } from "../../../../context/NotificationContext";
import SearchWalkthrough from "../../../../Components/walk-through-common-components/homeScreenTooltips/SearchWalkthrough";
import WalletWalkthrough from "../../../../Components/walk-through-common-components/homeScreenTooltips/WalletWalkthrough";
import ChatWalkthrough from "../../../../Components/walk-through-common-components/homeScreenTooltips/ChatWalkthrough";
import NotificationWalkthrough from "../../../../Components/walk-through-common-components/homeScreenTooltips/NotificationWalkthrough";
import ProfileWalkthrough from "../../../../Components/walk-through-common-components/homeScreenTooltips/ProfileWalkthrough";
import Avatar from "../../../../Components/choose-avatar-components/Avatar";
import SvgImage from "../../../../Components/choose-avatar-components/SvgImage";

const Header = ({
  btnWalletTapped,
  btnStartTutorialTapped,
  btnMessageTapped,
  btnNotificationTapped,
  btnProfileTapped,
  btnSearchTapped,
  displayTutorialButton = false,
}: {
  btnWalletTapped?: () => void;
  btnStartTutorialTapped?: () => void;
  btnMessageTapped?: () => void;
  btnNotificationTapped?: () => void;
  btnProfileTapped?: () => void;
  btnSearchTapped?: any;
  displayTutorialButton?: boolean;
}) => {
  type SearchScreenParams = {
    txtSearch?: string;
  };
  const isAdmin = useAdminStatus();
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const isMobile =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  const walletIconRef = useRef<View>(null);
  const NotificationIconRef = useRef<View>(null);
  const messageIconRef = useRef<View>(null);
  const profileIconRef = useRef<View>(null);
  const navigation = useNavigation();
  const route = useRoute<RouteProp<Record<string, SearchScreenParams>>>();
  const [isWalletPopupVisible, setWalletPopupVisible] = useState(false);
  const [isNotificationPopupVisible, setNotificationPopupVisible] =
    useState(false);
  const [referAndEarnPopUp, setReferAndEarnPopUp] = useState(false);
  const [isMessagePopupVisible, setMessagePopupVisible] = useState(false);
  const [isProfilePopupVisible, setProfilePopupVisible] = useState(false);
  const [isOnChatScreen, setIsOnChatScreen] = useState(false);
  const [popupPosition, setPopupPosition] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });
  const {
    userData,
    userProfileData,
    accessToken,
    isProfileLoading,
    fetchUserProfile,
  } = useUserData();
  const [totalCoins, setTotalCoins] = useState(0);
  const [dailyCheckInPopup, setDailyCheckInPopup] = useState(false);
  const [ChangesApproved, setChangesApproved] = useState(false);
  const [links, setLinks] = useState({
    instagram: "",
    x: "",
    facebook: "",
  });
  const [referralCode, setReferralCode] = useState("");
  const [checkInData, setCheckInData] = useState(null);
  const [showCustomToast, setShowCustomToast] = useState(false);
  const [showCustomCoinToast, setShowCustomCoinToast] = useState(false);
  const [customCoinToastText, setCustomCoinToastText] = useState("");
  const [customCoinToastDay, setCustomCoinToastDay] = useState(0);
  const [customCoinToastCoin, setCustomCoinToastCoin] = useState(0);
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [numberOfBelts, setNumberOfBelts] = useState("0");
  const [arrBeltMedalType, setArrBeltMedalType] = useState([
    {
      id: 0,
      value: 0,
      image: AppImages.icCoinBelt,
      isAvailableAmountSelected: 1,
      title: "Coin",
      isSelected: false,
      currentPrize: 0,
      sellPrice: 0,
      locked: true,
      purchaseLock: true,
      stakeTokenAmount: 0,
      stakeBeltAmount: 0,
      stakeCurrencyAmount: 0,
      purchasedBeltAmount: 0,
      width:
        deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
          ? 69
          : 77,
      height: 69,
      popupIconWidth: 58,
    },

    {
      id: 0,
      image: AppImages.icBronzeBelt,
      title: "Bronze",
      isSelected: true,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: false,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 1,
      image: AppImages.icSilverBelt,
      title: "Silver",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      image: AppImages.icGoldBelt,
      title: "Gold",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      image: AppImages.icPlatinumBelt,
      title: "Platinum",
      isSelected: false,
      currentPrize: 0,
      value: 0,
      sellPrice: 0,
      purchaseLock: true,
      purchaseToken: 0,
      purchasedBeltAmount: 0,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  const [saleBeltModal, setSaleBeltModal] = useState(false);
  const [redeemBalance, setRedeemBalance] = useState(false);
  const [isKoBlitzHovered, setIsKoBlitzHovered] = useState(false);
  const koBlitzButtonRef = useRef<View>(null);
  const searchQuery =
    route.name === AppScreens.SearchEventWebScreen
      ? route.params?.txtSearch || ""
      : "";

  const [searchEvent, setSearchEvent] = useState(searchQuery);
  const searchInputRef = useRef(null);
  const { chatNotificationCount, setChatNotificationCount, fetchUserChats } =
    useChat();
  const {
    setNewNotificationCount,
    notificationCounts,
    isOnNotificationScreen,
    refreshNotificationCounts,
  } = useNotifications();

  const totalNotificationCount = notificationCounts.total;

  useEffect(() => {
    const focusInput = () => {
      if (route.name === AppScreens.SearchEventWebScreen) {
        setTimeout(() => {
          searchInputRef.current?.focus();
        }, 100);
      }
    };

    focusInput();
  }, [route.name]);

  // Track if we're on the chat screen to hide the badge
  useEffect(() => {
    const timeout = setTimeout(() => {
      const currentUrl = window.location.href;
      setIsOnChatScreen(currentUrl.includes("/messages"));
    }, 1000);

    return () => clearTimeout(timeout);
  }, [window.location.href]);

  const handleNavigateToNotifications = async () => {
    setNewNotificationCount(0);
    // Refresh notification counts to ensure synchronization
    await refreshNotificationCounts();
  };

  useEffect(() => {
    const getStoredChatCount = async () => {
      const storedChatCount = await AsyncStorage.getItem(
        "chatNotificationCount"
      );
      if (storedChatCount) {
        setChatNotificationCount(parseInt(storedChatCount, 10));
      }
    };
    getStoredChatCount();
  }, []);
  useEffect(() => {
    if (chatNotificationCount !== 0) {
      AsyncStorage.setItem("chatNotificationCount", `${chatNotificationCount}`);
    }
  }, [chatNotificationCount]);
  useEffect(() => {
    if (route.name === AppScreens.SearchEventWebScreen) {
      setSearchEvent(route.params?.txtSearch || "");
    }
  }, [route]);

  const handleWalletTapped = () => {
    walletIconRef.current?.measure((fx, fy, width, height, px, py) => {
      setPopupPosition({ x: px, y: py + height, width, height });
    });
    setWalletPopupVisible(true);
  };

  const handleNotificationTapped = () => {
    if (NotificationIconRef.current) {
      NotificationIconRef.current.measure((fx, fy, width, height, px, py) => {
        setPopupPosition({ x: px, y: py + height, width, height });
      });
      setNotificationPopupVisible(true);
    } else {
      console.error("NotificationIconRef is not attached to a view.");
    }
  };

  const handleMessageTapped = async () => {
    if (messageIconRef.current) {
      messageIconRef.current.measure((fx, fy, width, height, px, py) => {
        setPopupPosition({ x: px, y: py + height, width, height });
      });
      setMessagePopupVisible(true);
    } else {
      console.error("MessageIconRef is not attached to a view.");
    }
  };
  const handleProfileTapped = () => {
    if (profileIconRef.current) {
      profileIconRef.current.measure((fx, fy, width, height, px, py) => {
        setPopupPosition({ x: px, y: py + height, width, height });
      });
      setProfilePopupVisible(true);
    } else {
      console.error("ProfileIconRef is not attached to a view.");
    }
  };

  // Handle Go to KO Blitz button press
  const handleGoToBlitz = () => {
    // Check if blitz tokens are available in userData
    const blitzData = userData?.blitz;

    // Build Blitz URL with or without token
    let blitzUrl = dynamicBlitzUrl;

    if (blitzData && blitzData.refreshToken) {
      // Add refresh token as query param if available
      blitzUrl = `${dynamicBlitzUrl}/?refreshToken=${encodeURIComponent(
        blitzData.refreshToken
      )}`;
      console.log("Redirecting to Blitz with token:", blitzUrl);
    } else {
      // Redirect without token
      console.log("Redirecting to Blitz without token:", blitzUrl);
    }

    if (typeof window !== "undefined") {
      window.open(blitzUrl, "_blank");
    }
  };

  const closePopup = () => {
    setWalletPopupVisible(false);
    setNotificationPopupVisible(false);
    setMessagePopupVisible(false);
    setProfilePopupVisible(false);
    // setDailyCheckInPopup(false);
  };
  const handleSearchButtonPress = () => {
    if (
      searchEvent.length >= 3 &&
      (route.name !== AppScreens.SearchEventWebScreen ||
        route.params?.txtSearch !== searchEvent)
    ) {
      navigateToScreen(navigation, AppScreens.SearchEventWebScreen, {
        txtSearch: searchEvent,
      });
    }
  };

  // Debounce search input to avoid frequent triggers
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchEvent.length >= 3) {
        handleSearchButtonPress();
      }
    }, 500); // 500ms debounce delay

    return () => {
      clearTimeout(handler);
    };
  }, [searchEvent]);

  // toast if streak breaks but it renderers 3 times so it's commented

  function checkLoginTime(dailyCheckInResult) {
    const today = new Date().toDateString();
    const closePopupDate = dailyCheckInResult?.closePopupDate;

    // Check localStorage flag for claim coins suppression (persists across redirects)
    const suppressClaimCoinsToday = localStorage.getItem(
      "suppressClaimCoinsPopup_" + today
    );
    if (suppressClaimCoinsToday === "true") {
      console.log(
        "🚫 Suppressing Claim Coins popup due to localStorage flag for today:",
        today
      );
      setDailyCheckInPopup(false);
      return;
    }

    // Check if we should suppress Claim Coins popup due to active signup flow
    const signupFlowContextStr = sessionStorage.getItem("signupFlowContext");
    if (signupFlowContextStr) {
      try {
        const signupFlowContext = JSON.parse(signupFlowContextStr);
        if (signupFlowContext.suppressClaimCoinsPopup) {
          console.log(
            "🚫 Suppressing Claim Coins popup due to signup flow:",
            signupFlowContext.flowType
          );

          // Store localStorage flag to prevent popup for the rest of the day
          localStorage.setItem("suppressClaimCoinsPopup_" + today, "true");
          console.log(
            "💾 Stored localStorage flag to suppress claim coins for today"
          );

          setDailyCheckInPopup(false);
          return;
        }
      } catch (error) {
        console.warn("⚠️ Error parsing signup flow context in Header:", error);
      }
    }

    // If popup was already closed today, don't show it
    if (closePopupDate && closePopupDate === today) {
      setDailyCheckInPopup(false);
      return;
    }

    // AUTOMATIC POPUP DISABLED - Users can still open manually from wallet
    // TODO: Review and re-enable later if needed
    // The popup was sometimes working and sometimes not, so disabled for now

    // Show popup if user has unclaimed coins
    // if (
    //   dailyCheckInResult?.unclaimedCoins > 0 &&
    //   dailyCheckInResult?.claimed === false
    // ) {
    //   setDailyCheckInPopup(true);
    //   return;
    // }

    // Legacy logic for time-based check-ins
    // if (
    //   dailyCheckInResult?.lastCheckInTime &&
    //   dailyCheckInResult?.currentCheckInTime
    // ) {
    //   const currentCheckInTime = new Date(
    //     dailyCheckInResult?.currentCheckInTime
    //   ).getTime();
    //   const lastCheckInTime = new Date(
    //     dailyCheckInResult?.lastCheckInTime
    //   ).getTime();
    //   const timeDiff = currentCheckInTime - lastCheckInTime;

    //   if (timeDiff > 24 * 60 * 60 * 1000) {
    //     if (
    //       dailyCheckInResult?.closePopup !== undefined &&
    //       dailyCheckInResult?.closePopup
    //     ) {
    //       const currentCheckInDate = new Date(
    //         dailyCheckInResult.currentCheckInTime
    //       ).toDateString();

    //       if (currentCheckInDate === today) {
    //         setDailyCheckInPopup(false);
    //       } else {
    //         setDailyCheckInPopup(true);
    //       }
    //     } else {
    //       setDailyCheckInPopup(true);
    //     }
    //   } else {
    //     setDailyCheckInPopup(false);
    //   }
    // } else {
    //   setDailyCheckInPopup(false);
    // }

    // Always keep popup closed on login (users can open manually)
    setDailyCheckInPopup(false);
  }

  useEffect(() => {
    if (showCustomToast) {
      setCustomToastDetails(checkInData);
    }
  }, [showCustomToast]);

  function setCustomToastDetails(checkInData) {
    switch (checkInData.streak) {
      case 1:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(1);
        setCustomCoinToastText(
          `Great start! You’ve earned ${checkInData.coinReward} coins for today’s check-in. Keep coming back for bigger rewards tomorrow!`
        );
        break;

      case 2:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(2);
        setCustomCoinToastText(
          `You’re on a roll! You’ve earned ${checkInData.coinReward} coins today. Log in tomorrow to keep the streak alive and earn even more!`
        );
        break;

      case 3:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(3);
        setCustomCoinToastText(
          `Consistency pays off! You’ve earned ${checkInData.coinReward} coins today. You’re building your stash like a pro!`
        );
        break;
      case 4:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(4);
        setCustomCoinToastText(
          `You’re unstoppable! ${checkInData.coinReward} coins added to your stash today. Keep going to hit those big rewards!`
        );
        break;
      case 5:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(5);
        setCustomCoinToastText(
          `High five! You’ve earned ${checkInData.coinReward} coins for today’s check-in. Two more days for the big finish!`
        );
        break;
      case 6:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(6);
        setCustomCoinToastText(
          `Almost there! You’ve earned ${checkInData.coinReward} coins today. Don’t stop now—tomorrow is your jackpot day!`
        );
        break;
      case 7:
        setCustomCoinToastCoin(checkInData.coinReward);
        setCustomCoinToastDay(7);
        setCustomCoinToastText(
          `Jackpot! You’ve earned ${checkInData.coinReward} coins for completing your weekly streak, bringing your total to 335 coins this week. Your stash is looking solid—reset and do it again!`
        );
        break;
      default:
        break;
    }
    setShowCustomCoinToast(true);
  }

  const initializeHeaderData = useCallback(() => {
    if (userData && accessToken) {
      setCheckInData(userData.dailyCheckInResult);
      checkLoginTime(userData.dailyCheckInResult);
      checkUserBalanceAPI(accessToken);
      paymentBeltExchangeAPI(accessToken);
    }
  }, [userData, accessToken]);

  useEffect(() => {
    initializeHeaderData();
  }, [initializeHeaderData]);

  // Fetch message count on component mount
  useEffect(() => {
    if (accessToken && userData) {
      const messagePopup = true;
      fetchUserChats(null, messagePopup);
    }
  }, [accessToken, userData]);

  // Update local state when userProfileData changes
  useEffect(() => {
    if (userProfileData) {
      setReferralCode(userProfileData.referralCode || "");
      setLinks({
        instagram: userProfileData.socialLinks?.instagramLink || "",
        x: userProfileData.socialLinks?.xLink || "",
        facebook: userProfileData.socialLinks?.facebookLink || "",
      });
      setTotalCoins(userProfileData.coins || 0);
    }
  }, [userProfileData]);

  const callUpdateReferralCodeAPI = (generatedReferralCode) => {
    if (referralCode.trim().length > 0) {
      return;
    }
    const params = {
      username: userProfileData.userID,
      accessToken: accessToken,
      referralCode: generatedReferralCode,
    };

    fetch(base_url + endpoints.auth.updateProfile, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: params,
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.statusCode === 200) {
          setReferralCode(generatedReferralCode);
          console.log("Referral Code Added successfully.");
        } else {
          toast.error(json.body.error);
        }
      })
      .catch((error) => {
        toast.error("error :", error);
      });
  };

  useEffect(() => {
    const storeProfileData = async () => {
      if (userProfileData?.profilePicture && userProfileData?.userID) {
        try {
          await AsyncStorage.setItem(
            "profilePicture",
            userProfileData.profilePicture
          );
          await AsyncStorage.setItem("userID", userProfileData.userID);
        } catch (error) {
          console.error("Error saving data to AsyncStorage:", error);
        }
      }
    };
    if (userProfileData) {
      storeProfileData();
    }
  }, [userProfileData]);
  useEffect(() => {
    async function loadProfileData() {
      try {
        const storedProfilePicture = await AsyncStorage.getItem(
          "profilePicture"
        );
        const storedUserID = await AsyncStorage.getItem("userID");
        if (storedUserID || storedProfilePicture) {
          // Profile data is now managed by UserDataContext
          // This is just for loading stored data on component mount
          // The actual updates are handled by the context
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    }

    loadProfileData();
  }, []);
  const checkUserBalanceAPI = async (userAccessToken) => {
    try {
      const data = await fetchUserBalanceEnhanced(userAccessToken);

      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      if (data) {
        setUserBalanceData(responseBody);
        const belts = responseBody?.belts;

        // Only update belt values if belts data exists
        if (belts) {
          const arr = [...arrBeltMedalType];
          arr.map((item) => {
            if (item.title === "Bronze") item.value = Number(belts.bronze || 0);
            else if (item.title === "Silver")
              item.value = Number(belts.silver || 0);
            else if (item.title === "Gold")
              item.value = Number(belts.gold || 0);
            else if (item.title === "Platinum")
              item.value = Number(belts.platinum || 0);
          });
          setArrBeltMedalType(arr);
        }
      } else {
        handleApiError(data.statusCode, data.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    if (refreshAPICall) {
      // Profile refresh is now handled by UserDataContext
      setRefreshAPICall(false);
    }
  }, [refreshAPICall]);

  // Belt purchase cost in tokens (what you PAY to BUY a belt)
  const beltPurchaseRates = {
    Bronze: 550,
    Silver: 5500,
    Gold: 55000,
    Platinum: 550000,
  };

  const paymentBeltExchangeAPI = async (userAccessToken) => {
    try {
      const response = await fetchPaymentBeltExchangeEnhanced(userAccessToken);
      if (response.statusCode === 200) {
        const arr = [...arrBeltMedalType];
        arr.map((item) => {
          if (item.title === "Bronze") {
            item.currentPrize = beltPurchaseRates.Bronze;
            item.sellPrice = Number(response.sellRates.bronze);
          } else if (item.title === "Silver") {
            item.currentPrize = beltPurchaseRates.Silver;
            item.sellPrice = Number(response.sellRates.silver);
          } else if (item.title === "Gold") {
            item.currentPrize = beltPurchaseRates.Gold;
            item.sellPrice = Number(response.sellRates.gold);
          } else if (item.title === "Platinum") {
            item.currentPrize = beltPurchaseRates.Platinum;
            item.sellPrice = Number(response.sellRates.platinum);
          }
        });
        setArrBeltMedalType(arr);
      } else {
        handleApiError(response.statusCode, response.error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <View style={styles.container}>
      <View style={{ flexDirection: "row", gap: 15, alignItems: "center" }}>
        {deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.MD ||
        deviceSize === DEVICE_SIZES.LG ? (
          <TouchableOpacity
            onPress={() => {
              navigateToScreen(navigation, AppScreens.DrawerRoute);
            }}
          >
            <Image
              source={AppImages.KO_LOGO_Main}
              style={{ width: 70, height: 45 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        ) : null}
        <SearchWalkthrough
          content={
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG ? (
              <TouchableOpacity
                onPress={() => {
                  btnSearchTapped();
                }}
              >
                <Image
                  source={AppImages.icSearchWhite}
                  style={{ width: 26, height: 28 }}
                />
              </TouchableOpacity>
            ) : (
              <View
                style={{
                  width: 314,
                }}
              >
                <CommonTextInputWeb
                  refValue={searchInputRef}
                  placeholder="Search here"
                  mainStyle={[styles.textInputStyle]}
                  inputStyle={[
                    AppFontStyle.REGULAR_ANYBODY_14,
                    { paddingVertical: 0, paddingHorizontal: 0 },
                  ]}
                  keyboardType="default"
                  value={searchEvent}
                  onChangeText={setSearchEvent}
                  prefixIconVisibility={true}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                    handleSearchButtonPress();
                  }}
                  autoCapitalize="none"
                  isPassword={false}
                  prefixIcon={AppImages.icSearchWhite}
                  iconStyle={{ width: 24, height: 24 }}
                />
              </View>
            )
          }
        />
      </View>
      {isAdmin ? (
        <>
          <View ref={profileIconRef}>
            <TouchableOpacity
              onPress={handleProfileTapped}
              style={{
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                gap: 10,
              }}
            >
              <View
                style={{
                  backgroundColor: AppColors.lightPurple_604e74,
                  borderRadius: 40,
                  overflow: "hidden",
                }}
              >
                <Avatar
                  src={userProfileData?.profilePicture}
                  variant="profile"
                />
              </View>
              <Text style={[AppFontStyle.BOLD_ANYBODY_18, {}]}>
                {userProfileData?.userID}
              </Text>
            </TouchableOpacity>
          </View>

          <ProfilePopup
            isVisible={isProfilePopupVisible}
            onClose={closePopup}
            position={popupPosition}
            accessToken={accessToken}
            userProfileData={userProfileData}
            setReferAndEarnPopUp={setReferAndEarnPopUp}
          />
        </>
      ) : (
        <View style={{ flexDirection: "row", gap: 20, alignItems: "center" }}>
          {/* KO Blitz Button */}
          <View
            ref={koBlitzButtonRef}
            style={{ position: "relative" }}
            // @ts-ignore - onMouseEnter/Leave work on web
            onMouseEnter={() => setIsKoBlitzHovered(true)}
            onMouseLeave={() => setIsKoBlitzHovered(false)}
          >
            <TouchableOpacity
              onPress={handleGoToBlitz}
              style={{
                display: "flex",
                height: isMobile ? 29 : 40,
                paddingHorizontal: isMobile ? 12 : 24,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 6,
                backgroundColor: "#DC2626",
                width: isMobile ? 116 : "auto",
              }}
            >
              <LinearGradient
                colors={["#DC2626", "#991B1B"]}
                start={[0, 0]}
                end={[1, 0]}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: 6,
                }}
              />
              <Text
                style={{
                  color: "#FFF",
                  fontSize: isMobile ? 10 : 12,
                  fontWeight: "600",
                  lineHeight: 20,
                }}
              >
                Go to KO Blitz
              </Text>
            </TouchableOpacity>

            {/* Hover Dropdown */}
            {isKoBlitzHovered && !isMobile && (
              <View
                style={{
                  position: "absolute",
                  top: 50,
                  left: 0,
                  padding: 12,
                  borderRadius: 8,
                  borderWidth: 1,
                  borderColor: "#3F3F3F",
                  backgroundColor: "#0A0D12",
                  width: 300,
                  zIndex: 9999,
                  elevation: 9999,
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.3,
                  shadowRadius: 8,
                }}
              >
                <Text
                  style={{
                    color: "#FFF",
                    fontSize: 14,
                    fontWeight: "700",
                    lineHeight: 20,
                    marginBottom: 4,
                  }}
                >
                  Go to Blitz dashboard
                </Text>
                <Text
                  style={{
                    color: "#FFF",
                    fontSize: 12,
                    fontWeight: "500",
                    lineHeight: 20,
                  }}
                >
                  Quick Matches. KO-Blitz lets you challenge friends, play
                  mini-games, and win prises.
                </Text>
              </View>
            )}
          </View>

          <WalletWalkthrough
            content={
              <View ref={walletIconRef}>
                <TouchableOpacity
                  onPress={handleWalletTapped}
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: isMobile ? 6 : 0,
                  }}
                >
                  <SvgImage src={AppImages.icWallet} variant="wallet" />
                </TouchableOpacity>
              </View>
            }
          />
          <WalletPopup
            isVisible={isWalletPopupVisible}
            onClose={closePopup}
            position={popupPosition}
            userProfileData={userProfileData}
            setDailyCheckInPopup={setDailyCheckInPopup}
            setChangesApproved={setChangesApproved}
            setCornfirmPurchaseBeltModal={setCornfirmPurchaseBeltModal}
            setRedeemBalance={setRedeemBalance}
          />

          {displayTutorialButton && !isMobile && (
            <TouchableOpacity
              onPress={() => btnStartTutorialTapped()}
              style={{
                borderWidth: 1,
                borderColor: AppColors.purple_9E77ED,
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_16,
                  {
                    fontWeight: 600,
                    borderWidth: 1,
                    borderColor: AppColors.white,
                    borderRadius: 8,
                    paddingHorizontal: 8,
                    paddingVertical: 6,
                  },
                ]}
              >
                Start Tutorial
              </Text>
            </TouchableOpacity>
          )}
          {deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG ? null : (
            <>
              <ChatWalkthrough
                content={
                  <View ref={messageIconRef}>
                    <TouchableOpacity
                      onPress={handleMessageTapped}
                      // onFocus={handleMessageTapped}
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <Image
                        source={AppImages.icMessageSvg}
                        resizeMode="contain"
                        style={{
                          height: 24,
                          width: 24,
                        }}
                      />
                      {chatNotificationCount > 0 && !isOnChatScreen && (
                        <View
                          style={{
                            position: "absolute",
                            right: -8,
                            top: -8,
                            backgroundColor: AppColors.red_EA3737,
                            borderRadius: 8,
                            height: 16,
                            minWidth: 16,
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10,
                            borderWidth: 1,
                            borderColor: AppColors.white,
                          }}
                        >
                          <Text
                            style={{
                              color: AppColors.white,
                              fontSize: 10,
                              fontWeight: "bold",
                              lineHeight: 12,
                            }}
                          >
                            {chatNotificationCount}
                          </Text>
                        </View>
                      )}
                    </TouchableOpacity>
                  </View>
                }
              />
              <MessagePopup
                isVisible={isMessagePopupVisible}
                onClose={closePopup}
                position={popupPosition}
              />
              <NotificationWalkthrough
                content={
                  <View ref={NotificationIconRef}>
                    <TouchableOpacity
                      onPress={() => {
                        handleNotificationTapped();
                        handleNavigateToNotifications();
                      }}
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      <Image
                        source={AppImages.icNotificationbing}
                        resizeMode="contain"
                        style={{
                          height: 24,
                          width: 24,
                        }}
                      />
                      {totalNotificationCount > 0 &&
                        !isOnNotificationScreen && (
                          <View
                            style={{
                              position: "absolute",
                              right: -8,
                              top: -8,
                              backgroundColor: AppColors.red_EA3737,
                              borderRadius: 8,
                              height: 16,
                              minWidth: 16,
                              justifyContent: "center",
                              alignItems: "center",
                              zIndex: 10,
                              borderWidth: 1,
                              borderColor: AppColors.white,
                            }}
                          >
                            <Text
                              style={{
                                color: AppColors.white,
                                fontSize: 10,
                                fontWeight: "bold",
                                lineHeight: 12,
                              }}
                            >
                              {totalNotificationCount}
                            </Text>
                          </View>
                        )}
                    </TouchableOpacity>
                  </View>
                }
              />

              <NotificationPopup
                isVisible={isNotificationPopupVisible}
                onClose={closePopup}
                position={popupPosition}
                accessToken={accessToken}
              />

              <ProfileWalkthrough
                content={
                  <View ref={profileIconRef}>
                    <TouchableOpacity
                      onPress={handleProfileTapped}
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "row",
                        gap: 10,
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: AppColors.lightPurple_604e74,
                          borderRadius: 40,
                          overflow: "hidden",
                        }}
                      >
                        <Avatar
                          src={userProfileData?.profilePicture}
                          variant="profile"
                        />
                      </View>
                      <Text style={[AppFontStyle.BOLD_ANYBODY_18, {}]}>
                        {userProfileData?.userID}
                      </Text>
                    </TouchableOpacity>
                  </View>
                }
              />

              <ProfilePopup
                isVisible={isProfilePopupVisible}
                onClose={closePopup}
                position={popupPosition}
                accessToken={accessToken}
                userProfileData={userProfileData}
                setReferAndEarnPopUp={setReferAndEarnPopUp}
              />
            </>
          )}
        </View>
      )}
      {dailyCheckInPopup && (
        <CheckInPopup
          showModal={dailyCheckInPopup}
          onClose={closePopup}
          setShowModal={setDailyCheckInPopup}
          checkInData={checkInData}
          setCheckInData={setCheckInData}
          accessToken={accessToken}
          userProfileAPI={fetchUserProfile}
          totalCoins={totalCoins}
          loginData={userData}
          setShowCustomToast={setShowCustomToast}
        />
      )}
      {ChangesApproved && (
        <CoinsPopup
          showModal={ChangesApproved}
          setShowModal={setChangesApproved}
          onClose={() => {}}
        />
      )}
      {referAndEarnPopUp && (
        <ReferAndEarn
          showModal={referAndEarnPopUp}
          setShowModal={setReferAndEarnPopUp}
          links={links}
          referralCode={referralCode}
          callUpdateReferralCodeAPI={callUpdateReferralCodeAPI}
          accessToken={accessToken}
        />
      )}
      {showCustomCoinToast && (
        <CustomCoinToast
          isVisible={showCustomCoinToast}
          onClose={() => setShowCustomCoinToast(false)}
          customCoinToastText={customCoinToastText}
          customCoinToastDay={customCoinToastDay}
          customCoinToastCoin={customCoinToastCoin}
        />
      )}
      {cornfirmPurchaseBeltModal && (
        <CornfirmPurchaseBeltModal
          accessToken={accessToken}
          numberOfBelts={numberOfBelts}
          setArrBeltMedalType={setArrBeltMedalType}
          arrBeltMedalType={arrBeltMedalType}
          showModal={cornfirmPurchaseBeltModal}
          setRefreshAPICall={setRefreshAPICall}
          userBalanceData={userBalanceData}
          setShowModal={setCornfirmPurchaseBeltModal}
          dataSelectedBelt={arrBeltMedalType.find((item) => item.isSelected)}
          selectedBelt={(data) => {
            setBeltPurchaseSuccessModal(true);
          }}
          jumpToPurchaseToken={(isNavigate: false) => {
            if (isNavigate) {
              navigateToScreen(navigation, AppScreens.PurchaseScreen);
            }
          }}
        />
      )}
      {/* BeltPurchaseSuccessModal  */}
      {beltPurchaseSuccessModal && (
        <BeltPurchaseSuccessModal
          setSaleBeltModal={setSaleBeltModal}
          arrBeltMedalType={arrBeltMedalType}
          showModal={beltPurchaseSuccessModal}
          setShowModal={setBeltPurchaseSuccessModal}
          numberOfBelts={numberOfBelts}
          dataBuyBelt={arrBeltMedalType.find((item) => item.isSelected)}
          // backProfileTapped={() => {
          //   reloadAPIs();
          // }}
        />
      )}
      {redeemBalance && (
        <RedeemCreditsModal
          showModal={redeemBalance}
          setShowModal={setRedeemBalance}
          userProfileData={userProfileData}
          accessToken={accessToken}
          setRefreshAPICall={setRefreshAPICall}
        />
      )}
    </View>
  );
};

export default Header;
const useStyles = CreateResponsiveStyle(
  {
    container: {
      height: 58,
      backgroundColor: "rgba(0, 0, 0, 0.80)",
      borderBottomWidth: 0.8,
      borderBottomColor: "#1F2937",
      justifyContent: "space-between",
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 10,
      gap: 20,
      position: "relative",
      zIndex: 1000,
    },
    textInputStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderWidth: 0,
      borderColor: "transparent",
      paddingHorizontal: 15,
      paddingVertical: 10,
      flex: 1,
    },
    iconStyle: {
      width: 40,
      height: 40,
    },
  },
  {
    [DEVICE_SIZES.SM]: {
      iconStyle: {
        width: 31,
        height: 31,
      },
    },
    [DEVICE_SIZES.XS]: {
      iconStyle: {
        width: 31,
        height: 31,
      },
    },
  }
);
